import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';

import { ISelectItemProps } from './models';
import styles from './styles.module.scss';

const SelectItem: React.FC<ISelectItemProps> = ({
  value,
  onChange,
  textByValue,
  values,
  emptyOptionText = '',
  className,
  dataTestId = 'selectItem',
}) => (
  <div className={classNames(styles.SelectItemWrapper, className)} data-testid={`${dataTestId}-wrapper`}>
    <select
      className={styles.SelectItem}
      value={value}
      onChange={onChange}
      data-testid={dataTestId}
    >
      {!value && <option value='' data-testid={`${dataTestId}-emptyValue`}>{emptyOptionText}</option>}
      {values.map((value, index) => (
        <option key={value} value={value} data-testid={`${dataTestId}-option${index}`}>{_.invoke(textByValue, value) || value}</option>
      ))}
    </select>
  </div>
);

export default SelectItem;
